import { render, staticRenderFns } from "./RequisiteSimpleRule.vue?vue&type=template&id=db4781fc&scoped=true"
import script from "./RequisiteSimpleRule.vue?vue&type=script&lang=js"
export * from "./RequisiteSimpleRule.vue?vue&type=script&lang=js"
import style0 from "./RequisiteSimpleRule.vue?vue&type=style&index=0&id=db4781fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4781fc",
  null
  
)

export default component.exports